// I controlli dei moduli e i pulsanti d'azione del design system: altezza
// control-height, radius-lg, bordo e fondo dei token, focus.
// Il focus di un campo è il bordo border-focus ispessito da un anello pieno di 1px (come Primer).
const CONTROL_BASE =
  'w-full rounded-lg border border-default bg-default px-3 text-sm text-default outline-hidden transition-colors duration-150 placeholder:text-placeholder focus:border-focus focus:ring-1 focus:ring-inset focus:ring-focus disabled:cursor-not-allowed disabled:opacity-60';

export const controlClass = `h-9 ${CONTROL_BASE}`;
export const textareaClass = `min-h-24 py-2 ${CONTROL_BASE}`;
/** Un campo di una barra di filtri: come gli altri, col testo caption delle toolbar. */
export const toolbarControlClass = controlClass.replace('text-sm', 'text-caption');
export const labelClass = 'mb-1 block text-xs font-medium text-muted';

/**
 * La forma di ogni pulsante, senza colori né larghezza. L'hover dei colori vale solo
 * da abilitato (`not-disabled:`), così un pulsante spento non reagisce al puntatore.
 */
export const buttonShapeClass =
  'inline-flex h-9 items-center justify-center gap-1 whitespace-nowrap rounded-lg text-caption font-semibold transition-colors duration-150 focus-visible:focus-ring disabled:cursor-not-allowed disabled:opacity-60';
const BUTTON = `${buttonShapeClass} px-3`;
const SECONDARY =
  'border border-default bg-default text-muted not-disabled:hover:border-hover not-disabled:hover:bg-muted not-disabled:hover:text-strong';

export const primaryButtonClass = `${BUTTON} bg-primary text-on-emphasis shadow-resting not-disabled:hover:bg-primary-hover`;
export const secondaryButtonClass = `${BUTTON} ${SECONDARY}`;
export const dangerButtonClass = `${BUTTON} bg-danger-emphasis text-on-emphasis shadow-resting not-disabled:hover:bg-danger-emphasis/90`;
/**
 * Un pulsante che resta premuto (filtro, modalità, vista), con `aria-pressed`: secondario
 * a riposo, pieno quando è scelto (bianco su `bg-selected`).
 */
export const toggleButtonClass = (pressed: boolean) =>
  `${BUTTON} ${pressed ? 'border border-transparent bg-selected text-on-emphasis shadow-raised' : SECONDARY}`;
/** Il pulsante secondario a sola icona: quadrato, con bordo. Va con un `aria-label`. */
export const secondaryIconButtonClass = `${buttonShapeClass} w-9 shrink-0 ${SECONDARY}`;
// Il pulsante a sola icona di una riga: il colore dell'hover lo aggiunge chi lo usa.
// Spento con `aria-disabled` resta raggiungibile, per il tooltip che spiega perché.
export const iconButtonClass =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-placeholder transition-colors duration-150 focus-visible:focus-ring disabled:cursor-not-allowed disabled:opacity-60 aria-disabled:cursor-not-allowed aria-disabled:opacity-60';
export const fileInputClass =
  'block w-full rounded-lg border border-default bg-default px-3 py-2 text-caption text-default file:mr-3 file:h-7 file:rounded-lg file:border file:border-default file:bg-default file:px-3 file:text-caption file:font-semibold file:text-muted hover:file:bg-muted focus-visible:focus-ring';

/** Un controllo di un'altra larghezza: nel CSS generato `w-full` vince su una larghezza aggiunta. */
export const controlWithWidth = (width: string, base = controlClass) =>
  base.replace('w-full', width);

const toInvalid = (base: string) =>
  base
    .replace('border-default', 'border-danger-emphasis')
    .replace('focus:border-focus', 'focus:border-danger-emphasis')
    .replace('focus:ring-focus', 'focus:ring-danger-emphasis');

/** Un controllo con un errore: bordo e focus passano al pericolo. */
export const invalidControlClass = toInvalid(controlClass);
export const invalidToolbarControlClass = toInvalid(toolbarControlClass);
export const invalidTextareaClass = toInvalid(textareaClass);
